var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5083 8.82861C9.1652 8.82861 8.81104 8.64323 8.4458 8.27246L1.17432 1.04248C1.47314 0.776855 1.98503 0.644043 2.70996 0.644043H16.1074C16.9209 0.644043 17.4937 0.782389 17.8257 1.05908L10.5708 8.27246C10.2056 8.64323 9.8514 8.82861 9.5083 8.82861ZM0.311035 13.9419C0.156087 13.6652 0.0786133 13.2197 0.0786133 12.6055V3.4248C0.0786133 2.78841 0.164388 2.32633 0.335938 2.03857L6.3374 7.95703L0.311035 13.9419ZM2.89258 15.3945C2.07357 15.3945 1.48698 15.2479 1.13281 14.9546L7.25879 8.87012L7.74854 9.35156C8.31852 9.90495 8.90511 10.1816 9.5083 10.1816C10.1115 10.1816 10.6981 9.90495 11.2681 9.35156L11.7578 8.86182L17.8921 14.9629C17.5711 15.2507 17.0371 15.3945 16.29 15.3945H2.89258ZM18.6973 13.9336L12.6792 7.95703L18.6724 2.05518C18.8384 2.33187 18.9214 2.78841 18.9214 3.4248V12.6055C18.9214 13.2142 18.8467 13.6569 18.6973 13.9336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2ba50417f986f75c6ddf857b3fcc91ad.svg";
export { ForwardRef as ReactComponent };